import { useTheme } from "next-themes";
import dynamic from "next/dynamic";

// 이모지 고르개는 300KB 라 **열 때만** 받아 온다.
// 댓글 입력창이 있는 화면(플레이 피드 포함)이 전부 이걸 먼저 받고 있었다.
const EmojiPicker = dynamic(() => import("emoji-picker-react"), { ssr: false });

const EmojiPickerInput = ({
  pickerWrapperClassName = "",
  onEmojiSelect,
  onClickOutside,
  previewPosition = "none",
  navPosition = "top",
  searchPosition = "sticky",
  maxFrequentRows = 4,
}) => {
  const { theme } = useTheme();
  return (
    <div className={pickerWrapperClassName}>
      <EmojiPicker
        open
        theme={theme}
        lazyLoadEmojis
        onEmojiClick={(emoji) =>
          onEmojiSelect?.({ native: emoji?.emoji, ...emoji })
        }
        onClickOutside={onClickOutside}
        previewConfig={{ showPreview: previewPosition !== "none" }}
        searchDisabled={searchPosition === "none"}
        skinTonesDisabled={navPosition === "none"}
        suggestedEmojisMode={maxFrequentRows > 0 ? "recent" : "none"}
      />
    </div>
  );
};

export default EmojiPickerInput;
